export var UrlMappingsKeys;
(function (UrlMappingsKeys) {
    UrlMappingsKeys["PRODUCT_PAGE"] = "wix.stores.sub_pages.product";
    UrlMappingsKeys["BLOG_POST"] = "wix.blog.sub_pages.post";
    UrlMappingsKeys["BLOG_POST_EDIT"] = "wix.blog.sub_pages.post.edit";
    UrlMappingsKeys["BLOG_POST_PREVIEW"] = "wix.blog.sub_pages.post.preview";
    UrlMappingsKeys["BLOG_CATEGORY"] = "wix.blog.sub_pages.category";
    UrlMappingsKeys["FORUM_CATEGORY"] = "wix.forum.sub_pages.category";
    UrlMappingsKeys["FORUM_CATEGORY_PAGINATION"] = "wix.forum.sub_pages.category.pagination";
    UrlMappingsKeys["FORUM_CATEGORY_CREATE_POST"] = "wix.forum.sub_pages.category.create-post";
    UrlMappingsKeys["FORUM_CATEGORY_CREATE_QUESTION"] = "wix.forum.sub_pages.category.create-question";
    UrlMappingsKeys["FORUM_POST"] = "wix.forum.sub_pages.post";
    UrlMappingsKeys["FORUM_POST_EDIT"] = "wix.forum.sub_pages.post.edit";
    UrlMappingsKeys["FORUM_POST_PAGINATION"] = "wix.forum.sub_pages.post.pagination";
    UrlMappingsKeys["FORUM_POST_DEEP_LINK_DATA"] = "wix.forum.sub_pages.post.deep-link-data";
    UrlMappingsKeys["FORUM_POST_PAGINATION_AND_DEEP_LINK_DATA"] = "wix.forum.sub_pages.post.pagination-and-deep-link-data";
    UrlMappingsKeys["GROUP"] = "wix.groups.sub_pages.group";
    UrlMappingsKeys["GROUP_POST"] = "wix.groups.sub_pages.post";
    UrlMappingsKeys["BOOKINGS_SERVICE_PAGE"] = "wix.bookings.sub_pages.service_page";
})(UrlMappingsKeys || (UrlMappingsKeys = {}));
//# sourceMappingURL=url-mappings-keys.js.map